export default {
    NEW: 'New',
    PUBLISHED: 'Published',
    DRAFT: 'Unpublished',
    ARCHIVED: 'Archived',
}